import { render, staticRenderFns } from "./ViewLabelComponent.vue?vue&type=template&id=28f540aa"
import script from "./ViewLabelComponent.vue?vue&type=script&lang=js"
export * from "./ViewLabelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports